import * as api from '../../api/api-proceso-judicial';
import { 
    GET_CONFIG_FORM21,
    GET_DATOS_ANTECEDENTES_JUDICIALES,
    GET_COMBO_COMPETENCIA,
    GET_COMBO_CORTE,
    GET_COMBO_TRIBUNALES,
    GET_COMBO_LIBROS,
    GET_COMBO_HITO_JUDICIAL,
    GET_GRILLA_HISTORIAL_JUDICIAL,
    POST_ACTUALIZAR_JUDICIAL,
    GET_CONFIG_FORM22,
    GET_COMBO_TIPO_GASTO,
    GET_COMBO_COBERTURA,
    GET_COMBO_MONEDAS,
    GET_GRILLA_HISTORIAL_GASTOS,
    POST_ACTUALIZAR_TIPO_GASTO,
    POST_ANULAR,
    SET_LOADING_JUDICIAL,
    SET_LOADING_GASTOS,
    LIMPIAR_REF
    
} from '../types';

export const configuracionFormAction21 = (query) => ({
    type: GET_CONFIG_FORM21,
    payload: api.getConfiguracionForm21(query)
});
export const configuracionFormAction22 = (query) => ({
    type: GET_CONFIG_FORM22,
    payload: api.getConfiguracionForm22(query)
});
export const obtenerAntecedentesJudiciales = (query) => ({
    type: GET_DATOS_ANTECEDENTES_JUDICIALES,
    payload: api.getDatosAntecendetesJudiciales(query)
});
export const obtenerComboCompetencia = (query) => ({
    type: GET_COMBO_COMPETENCIA,
    payload: api.getComboCompetencia(query)
});
export const obtenerComboCorte = (query) => ({
    type: GET_COMBO_CORTE,
    payload: api.getComboCorte(query)
});
export const obtenerComboTribunales = (query) => ({
    type: GET_COMBO_TRIBUNALES,
    payload: api.getComboTribunales(query)
});
export const obtenerComboLibros = (query) => ({
    type: GET_COMBO_LIBROS,
    payload: api.getComboLibros(query)
});
export const obtenerComboHitoJudicial = (query) => ({
    type: GET_COMBO_HITO_JUDICIAL,
    payload: api.getComboHitoJudicial(query)
});
export const obtenerGrillaHistorialJudicial = (query) => ({
    type: GET_GRILLA_HISTORIAL_JUDICIAL,
    payload: api.getGrillaHistorialJudicial(query)
});
export const postActualizarProcesoJudicial = (proceso) => ({
    type: POST_ACTUALIZAR_JUDICIAL,
    payload: api.actualizarProcesoJudicial(proceso)
});
export const obtenerComboTipoGasto = (query) => ({
    type: GET_COMBO_TIPO_GASTO,
    payload: api.getComboTipoGasto(query)
});
export const obtenerComboCobertura = (query) => ({
    type: GET_COMBO_COBERTURA,
    payload: api.getComboCobertura(query)
});
export const obtenerComboMonedas = (query) => ({
    type: GET_COMBO_MONEDAS,
    payload: api.getComboMonedas(query)
});
export const obtenerGrillaHistorialGastos = (query) => ({
    type: GET_GRILLA_HISTORIAL_GASTOS,
    payload: api.getGrillaHistorialGastos(query)
});
export const postActualizarTipoGastoJudicial = (gastos) => ({
    type: POST_ACTUALIZAR_TIPO_GASTO,
    payload: api.actualizarTipoGastos(gastos)
});
export const postAnularGato = (gastos) => ({
    type: POST_ANULAR,
    payload: api.postAnular(gastos)
});
export const cambiarLoadingJudicial = (loading) => ({
    type: SET_LOADING_JUDICIAL,
    payload: loading
});
export const cambiarLoadingGastos = (loading) => ({
    type: SET_LOADING_GASTOS,
    payload: loading
});
export const limpiarRefAction = (limp) => ({
    type: LIMPIAR_REF,
    payload: limp
});